export const HUB_ROWS = 2;
export const HUB_COLS = 5;
export const HUB_PAGE_SIZE = HUB_ROWS * HUB_COLS;

export function categorySlug(url: string): string {
  const m = url.match(/^\/c\/([^/?]+)/);
  return m?.[1] || "";
}
